export const colorVariantOptions = [
	"default", // gray
	"red",
	"yellow",
	"green",
	"cyan",
	"blue",
	"purple",
	"pink",
] as const;

export type ColorVariant = (typeof colorVariantOptions)[number];

export type ChipLevel = "primary" | "secondary";
